import { Component, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

@Component({
    selector: 'nova-date-dialog',
    templateUrl: './date-dialog.component.html',
    standalone: true,
    imports: [
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatDialogModule,
        MatDatepickerModule,
        FormsModule
    ]
})
export class DateDialogComponent {
    @Input() title = 'Edit';
    @Input() date: any;
    @Input() dateTitle: string;

    constructor(
        private readonly dialogRef: MatDialogRef<DateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { date: any; title: string; dateTitle: string }
    ) {
        this.title = data.title;
        this.date = data.date;
        this.dateTitle = data.dateTitle;
    }

    close(result: boolean) {
        this.dialogRef.close(result ? this.date : null);
    }
}
